import {SnackMsg} from "@/modules/models";

export default class SnackEvent extends CustomEvent<SnackMsg> {
    static readonly eventName = "at-snackmsg";

    constructor(snack: SnackMsg) {
        super(SnackEvent.eventName, {detail: snack, bubbles: true, cancelable: true, composed: false});
    }

    get snack(): SnackMsg {
        return super.detail;
    }
}